import React, { useMemo } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { PreviewPanelMoreDropdown } from '@atlassian/preview-panel/preview-panel-more-dropdown';
import { RovoSettingsModal } from '@atlassian/rovo-settings-modal/ui/rovo-settings-modal';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

const TEAMWORK_GRAPH_PREVIEW_PANEL_SURFACE = 'confluence-teamwork-graph-preview-panel';

const APPS_TAB_ID = 'discovery';

const i18n = defineMessages({
	manageConnections: {
		id: 'byline-connections.preview-panel.teamwork-graph.manage-connections',
		defaultMessage: 'Manage connections',
		description:
			'Label for the "Manage connections" item in the Teamwork Graph preview panel header dropdown menu.',
	},
});

const MoreActionsDropdown = ({
	open,
}: {
	open: (options?: { defaultTab?: string }) => void;
}): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const dropdownActions = useMemo(
		() => [
			{
				label: formatMessage(i18n.manageConnections),
				onClick: () => open({ defaultTab: APPS_TAB_ID }),
				testId: 'teamwork-graph-preview-panel.more-dropdown.manage-connections',
			},
		],
		[formatMessage, open],
	);
	return (
		<PreviewPanelMoreDropdown
			testId="teamwork-graph-preview-panel.more-dropdown"
			dropdownActions={dropdownActions}
		/>
	);
};

export const TeamworkGraphPreviewPanelMoreActions = (): React.JSX.Element | null => {
	const { cloudId, isRovoLLMEnabled } = useSessionData();

	if (!isRovoLLMEnabled) {
		return null;
	}

	return (
		<RovoSettingsModal
			product="confluence"
			cloudId={cloudId}
			surface={TEAMWORK_GRAPH_PREVIEW_PANEL_SURFACE}
		>
			{({ open }) => <MoreActionsDropdown open={open} />}
		</RovoSettingsModal>
	);
};
